import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

import LoginPage from '../pages/LoginPage';
import NotFoundPage from '../pages/NotFoundPage';
import Layout from '../components/UI/Layout';
import ReportPage from '../pages/ReportPage';
import CampaignsPage from '../pages/CampaignsPage';
import ContractsPage from '../pages/ContractsPage';
import TeamsPage from '../pages/TeamsPage';
import PositionsPage from '../pages/PositionsPage';
import ContractDetailPage from '../pages/ContractDetailPage';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import CharitySelectionPage from '../pages/CharitySelectionPage';
import PrivateCharityRoute from './PrivateCharityRoute';

const AppRoutes: React.FC = () => {

  // This serves to update routes & pages when the language change
  useSelector((state: RootState) => state.auth.language)

  return (
    <Routes>

      {/* Public Routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      {/* Private Routes */}
      <Route
        path="/charity"
        element={
          <PrivateRoute>
            <CharitySelectionPage />
          </PrivateRoute>
        }
      />
      <Route path="/"
        element={
          <PrivateRoute>
            <PrivateCharityRoute>
              <Layout />
            </PrivateCharityRoute>
          </PrivateRoute>
        }>
        <Route index element={<Navigate to="/contracts" replace />} />
        <Route
          path="/report"
          element={
            <PrivateRoute>
              <PrivateCharityRoute>
                <ReportPage />
              </PrivateCharityRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/contracts"
          element={
            <PrivateRoute>
              <PrivateCharityRoute>
                <ContractsPage />
              </PrivateCharityRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/contracts/:id"
          element={
            <PrivateRoute>
              <PrivateCharityRoute>
                <ContractDetailPage />
              </PrivateCharityRoute>
            </PrivateRoute>
          }
        />
        <Route
          path="/teams"
          element={
            <PrivateRoute>
              <PrivateCharityRoute>
                <TeamsPage />
              </PrivateCharityRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/campaigns"
          element={
            <PrivateRoute>
              <PrivateCharityRoute>
                <CampaignsPage />
              </PrivateCharityRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/positions"
          element={
            <PrivateRoute>
              <PrivateCharityRoute>
                <PositionsPage />
              </PrivateCharityRoute>
            </PrivateRoute>
          }
        />

      </Route>
      {/* Catch-all for unknown routes */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
